import React, { useEffect, useState } from "react";
import { get } from "../../../../../utils/api";

interface PermissionsProps {
  module: any;
  primary_key: any;
  primary_key_value: any;
}

const Permissions: React.FC<PermissionsProps> = (props) => {
  const [collections, setCollections] = useState<Array<any>>([]);

  useEffect(() => {
    getFields();
  }, [props.module]);

  const getFields = async () => {
    try {
      const response = await get(`${"field_settings"}`, {limit:200});
      const collectionsWithPermissions = response.data.data.map((e: any) => ({
        collection_name: e.collection_name,
        permissions: [
          { name: "create", enable: false },
          { name: "list", enable: false },
          { name: "edit", enable: false },
          { name: "delete", enable: false },
          { name: "export", enable: false },
        ],
      }));

      setCollections(collectionsWithPermissions);
    } catch (error) {
      console.error("Error fetching fields: ", error);
    }
  };

  const handleCheckboxChange = (
    collectionIndex: number,
    permissionIndex: number
  ) => {
    const updatedCollections = collections.map((collection, cIndex) => {
      if (cIndex === collectionIndex) {
        const updatedPermissions = collection.permissions.map(
          (permission: any, pIndex: number) => {
            if (pIndex === permissionIndex) {
              return { ...permission, enable: !permission.enable };
            }
            return permission;
          }
        );
        return { ...collection, permissions: updatedPermissions };
      }
      return collection;
    });
    setCollections(updatedCollections);
  };
  function toTitleCase(str: string): string {
    return str
      .toLowerCase()
      .split("_")
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ backgroundColor: "#f2f2f2", textAlign: "left" }}>
            <th style={{ padding: "8px", border: "1px solid #ddd" }}>
              Modules
            </th>
            <th style={{ padding: "8px", border: "1px solid #ddd" }}>Create</th>
            <th style={{ padding: "8px", border: "1px solid #ddd" }}>List</th>
            <th style={{ padding: "8px", border: "1px solid #ddd" }}>Edit</th>
            <th style={{ padding: "8px", border: "1px solid #ddd" }}>Delete</th>
            <th style={{ padding: "8px", border: "1px solid #ddd" }}>Export</th>
          </tr>
        </thead>
        <tbody>
          {collections.map((collection, collectionIndex) => (
            <tr key={collection.collection_name}>
              {/* <td style={{ padding: "8px", border: "1px solid #ddd" }}>{collection.collection_name}</td> */}
              <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                {toTitleCase(collection.collection_name)}
              </td>
              {collection.permissions.map(
                (permission: any, permissionIndex: number) => (
                  <td
                    key={permission.name}
                    style={{
                      padding: "8px",
                      border: "1px solid #ddd",
                      textAlign: "center",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={permission.enable}
                      onChange={() =>
                        handleCheckboxChange(collectionIndex, permissionIndex)
                      }
                    />
                  </td>
                )
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Permissions;
